import { t } from '@gem/modules/i18n';

import Entities from 'STORE';

export function openSupport(): void {
  const supportEmail = Entities.clientConfig.hostConfig.supportEmail || PROJECT_CONFIG.supportEmail;

  window
    .open(`mailto:${supportEmail}?subject=${t('support_email_subject_text')}`, '_blank')!
    .focus();
}
